import { useChatStore } from '@/store/chatStore';
import { useConfigStore } from '@/store/configStore';
import axios from 'axios';

// Create axios instance
const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

export const chatService = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sendMessage: async (content: any) => {
    // Use the provided webhookUrl or fallback value
    const webhookUrl = useChatStore.getState().webhookUrl;

    if (!webhookUrl) {
      throw new Error('Webhook URL is required');
    }

    const { requestHeaders } = useConfigStore.getState().config;

    const response = await api.post(webhookUrl, content, {
      headers: requestHeaders,
    });

    return response.data;
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sendFeedback: async (content: any, webhookUrl: string) => {
    if (!webhookUrl) {
      throw new Error('Webhook URL is required');
    }

    const { requestHeaders } = useConfigStore.getState().config;

    const response = await api.post(webhookUrl, content, {
      headers: requestHeaders,
    });

    return response.data;
  },
};
